export const requestTimeout = 5000
export const baseURL = process.env.API_URL || "https://pokeapi.co/api/v2"
export const theme = {
  color: {
    dark: '#000000',
    light: '#FFFFFF',
  },
};